//@flow
import * as Immutable from 'immutable';

import { UIFilter } from 'common/models/flow/UIFilter';
import I18nHelper from 'common/helpers/I18nHelper';
import DataUtils from 'common/utils/DataUtils';
import type { UIFilterModelType } from 'common/models/flow/UIFilter';

const translationsNamespace = ['translations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

class InternalUIFilter extends UIFilter {
    static fromJS(json: UIFilterModelType): InternalUIFilter {
        const state: Object = Object.assign({}, json);
        state.options = state.options
            ? Immutable.List(state.options)
            : state.options;
        return new this(Immutable.Map(state));
    }

    get label(): string {
        const label = this._state.get('label');

        if (DataUtils.isEmpty(label) && this.labelKey) {
            return nsTranslate(this.labelKey);
        }
        return label;
    }
}

export { InternalUIFilter as UIFilter };
